import React from "react"
import { Link } from "react-router-dom"
import Carousel from "react-bootstrap/Carousel"
import { CarouselComponent } from "../../components/Carousel/Carousel"
import { CarouselGridCardsComponent } from "../../components/CarouselGridCards/CarouselGridCards"
import mainBackground from "../../assets/img/mainBackground.png"
import { FaBrain, FaDatabase, FaProjectDiagram, FaCogs } from "react-icons/fa"
import "./Home.css"
import "./Projects-Horizontal.css"

export function Home() {
	return (
		<React.Fragment>
			<main className="page landing-page">
				{/* 1. Hero Section */}
				<section
					className="clean-block clean-hero"
					style={{
						backgroundImage: `url(${mainBackground})`,
						backgroundPosition: "center",
						backgroundSize: "cover",
						backgroundRepeat: "no-repeat",
					}}
				>
					<div className="text text-center px-3">
						<h1 className="hero-title">Ciência de dados e inteligência artificial na justiça e segurança pública</h1>
					</div>
				</section>

				{/* 2. Sobre o Núcleo */}
				<section id="section" className="clean-block clean-info py-5 bg-white">
					<div className="container">
						<div className="row justify-content-center">
							<div className="col-12 col-lg-10">
								<div className="about-intro-box p-4 p-md-5 rounded-4 shadow-sm border border-primary-subtle bg-light">
									<div className="d-flex align-items-center gap-2 mb-3">
										<span
											className="badge px-3 py-2 rounded-pill fw-semibold"
											style={{ backgroundColor: "#003d9c", color: "#ffffff", fontSize: "0.9rem" }}
										>
											Sobre o Núcleo
										</span>
									</div>
									<p className="text-secondary fs-6 leading-relaxed mb-0">
										O <strong>Núcleo de Ciência de Dados e Inteligência Artificial (NCDIA)</strong> da Universidade de Fortaleza, da Fundação Edson
										Queiroz, é um ambiente dedicado ao desenvolvimento de projetos de pesquisa e inovação através da análise de dados, da excelência
										de modelos matemáticos, estatísticos e computacionais, e da aplicação e aprimoramento de técnicas de inteligência artificial,
										utilizando processamento de linguagem natural, aprendizado de máquina e aprendizado profundo.
									</p>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* 3. Áreas de Atuação */}
				<section className="clean-block features py-5 bg-light">
					<div className="container">
						<div className="block-heading text-center mb-5">
							<h2 className="fw-bold text-dark">Áreas de Atuação</h2>
						</div>

						<div className="row g-4 justify-content-center">
							<div className="col-12 col-sm-6 col-lg-3 d-flex">
								<div className="feature-modern-card text-center p-4 rounded-4 shadow-sm bg-white w-100 d-flex flex-column">
									<div className="feature-icon-circle icon-ds mb-3 mx-auto">
										<FaDatabase size={26} />
									</div>
									<h4 className="fw-bold fs-5 text-dark mb-0">Ciência de Dados</h4>
								</div>
							</div>

							<div className="col-12 col-sm-6 col-lg-3 d-flex">
								<div className="feature-modern-card text-center p-4 rounded-4 shadow-sm bg-white w-100 d-flex flex-column">
									<div className="feature-icon-circle icon-ai mb-3 mx-auto">
										<FaBrain size={26} />
									</div>
									<h4 className="fw-bold fs-5 text-dark mb-0">Inteligência Artificial</h4>
								</div>
							</div>

							<div className="col-12 col-sm-6 col-lg-3 d-flex">
								<div className="feature-modern-card text-center p-4 rounded-4 shadow-sm bg-white w-100 d-flex flex-column">
									<div className="feature-icon-circle icon-networks mb-3 mx-auto">
										<FaProjectDiagram size={26} />
									</div>
									<h4 className="fw-bold fs-5 text-dark mb-0">Redes Complexas</h4>
								</div>
							</div>

							<div className="col-12 col-sm-6 col-lg-3 d-flex">
								<div className="feature-modern-card text-center p-4 rounded-4 shadow-sm bg-white w-100 d-flex flex-column">
									<div className="feature-icon-circle icon-mining mb-3 mx-auto">
										<FaCogs size={26} />
									</div>
									<h4 className="fw-bold fs-5 text-dark mb-0">Mineração de Processos</h4>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* 4. Recursos Principais */}
				<section id="section" className="clean-block slider py-5 bg-white">
					<div className="container">
						<div className="block-heading text-center mb-4">
							<h2 className="fw-bold text-dark">Recursos Principais</h2>
						</div>
						<CarouselComponent path="published/resources" category="resources" />
						<div className="text-center mt-4">
							<Link to="/resources" className="btn btn-outline-primary px-4 py-2 rounded-pill fw-semibold">
								Ver todos os recursos &rarr;
							</Link>
						</div>
					</div>
				</section>

				{/* 5. Publicações */}
				<section id="section" className="projects-horizontal py-5 bg-light">
					<div className="container">
						<div className="intro text-center mb-4">
							<h2 className="fw-bold text-dark">Publicações</h2>
						</div>
					</div>
					<CarouselGridCardsComponent path="published/publications" category="publications" />
					<div className="text-center mt-2">
						<Link to="/publications" className="btn btn-outline-primary px-4 py-2 rounded-pill fw-semibold">
							Ver todas as publicações &rarr;
						</Link>
					</div>
				</section>

				{/* 6. Equipe */}
				<section id="section" className="clean-block slider py-5 bg-white">
					<div className="container">
						<div className="block-heading text-center mb-4">
							<h2 className="fw-bold text-dark">Nossa Equipe</h2>
						</div>

						<div className="team-carousel-container rounded-4 shadow-sm overflow-hidden border">
							<Carousel id="carousel-team" interval={5000}>
								<Carousel.Item style={{ maxHeight: "500px", minHeight: "350px", backgroundColor: "#0f172a" }}>
									<Link to="/about">
										<img
											className="team-carousel-image d-block w-100"
											src="/assets/img/team/IMG_2248.jpg"
											alt="Equipe NCDIA UNIFOR"
											style={{ objectFit: "cover", height: "450px" }}
										/>
									</Link>
									<Carousel.Caption className="text-center mb-3">
										<h3 className="h4 fw-bold text-white mb-1" style={{ textShadow: "0 2px 8px rgba(0, 0, 0, 0.85)" }}>
											Membros do Time NCDIA
										</h3>
										<p className="text-white small mb-0" style={{ textShadow: "0 1px 6px rgba(0, 0, 0, 0.85)" }}>
											Conheça os membros do nosso time
										</p>
									</Carousel.Caption>
								</Carousel.Item>
								<Carousel.Item style={{ maxHeight: "500px", minHeight: "350px", backgroundColor: "#0f172a" }}>
									<Link to="/about">
										<img
											className="team-carousel-image d-block w-100"
											src="/assets/img/team/IMG_2311.jpg"
											alt="Equipe NCDIA UNIFOR 2"
											style={{ objectFit: "cover", height: "450px" }}
										/>
									</Link>
									<Carousel.Caption className="text-center mb-3">
										<h3 className="h4 fw-bold text-white mb-1" style={{ textShadow: "0 2px 8px rgba(0, 0, 0, 0.85)" }}>
											Excelência e Inovação
										</h3>
										<p className="text-white small mb-0" style={{ textShadow: "0 1px 6px rgba(0, 0, 0, 0.85)" }}>
											Conheça os membros do nosso time
										</p>
									</Carousel.Caption>
								</Carousel.Item>
							</Carousel>
						</div>
					</div>
				</section>
			</main>
		</React.Fragment>
	)
}
